





























import { Vue, Component } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { SaveTagUseCase } from '@/usecases'

@Component

export default class DialogoDeEdicaoDeTag extends Vue {
	tag = {id:"", nome:""}
	mostra = false
	salvando = false
	saveTagUseCase = new SaveTagUseCase()

	mostrar(tag) {
		this.mostra = true
		this.tag = tag
	}

	esconder() {
		this.mostra = false
	}

	salvar() {
		if (!this.tag) return
		try {
			this.salvando = true
			const tag = this.tag

			const tagSalva = this.tag.id
				? this.saveTagUseCase.update(tag)
				: this.saveTagUseCase.create(tag)

			this.$emit('confirmado', tagSalva)
			this.mostra = false
			AlertModule.setSuccess('Tag salva com sucesso')
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}
}
